

























import { Dialog, Button } from 'element-ui'
import { Component, Vue, Prop } from 'vue-property-decorator'

import ConfirmationModalTypes from '@/models/confirmation-modal-types'

@Component({
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
  },
})
export default class ConfirmationModal extends Vue {
  @Prop() visible!: boolean
  @Prop() onAccept!: () => void
  @Prop({ type: String, default: ConfirmationModalTypes.Regular })
  type!: ConfirmationModalTypes
}
